module.exports = __webpack_public_path__ + "static/media/coertrasenberg.5d824e29.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/coertrasenberg.webp
// module id = 688
// module chunks = 0